import React from 'react'

export default function ApplicationForm() {
  return (
    <>
        <div className="form-application">
            <h1 className="p-heading">Application Form</h1>
            <form className='flex fd-col'>
            <label htmlFor="name">Name : </label>
            <input type="text" name="name" id="name" />
            <label htmlFor="email">E-Mail : </label>
            <input type="email" name="email" id="email" />
            <label htmlFor="number">Contact Number : </label>
            <input type="tel" name="number" id="number" />
            <button className='submitbtn'>Submit</button>
            </form>
        </div>
    </>
  )
}
